import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const DEFAULT_VIEWBOX = "0 0 20 20";
const CopyIcon = ({ fill = "currentColor", viewBox = DEFAULT_VIEWBOX, ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { viewBox, ...rest, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M3.33366 1.66699C2.41283 1.66699 1.66699 2.41283 1.66699 3.33366V14.167C1.66699 14.627 2.04033 15.0003 2.50033 15.0003C2.96033 15.0003 3.33366 14.627 3.33366 14.167V3.33366H14.167C14.627 3.33366 15.0003 2.96033 15.0003 2.50033C15.0003 2.04033 14.627 1.66699 14.167 1.66699H3.33366ZM6.66699 5.00033C5.74616 5.00033 5.00033 5.74616 5.00033 6.66699V16.667C5.00033 17.5878 5.74616 18.3337 6.66699 18.3337H16.667C17.5878 18.3337 18.3337 17.5878 18.3337 16.667V6.66699C18.3337 5.74616 17.5878 5.00033 16.667 5.00033H6.66699ZM6.66699 6.66699H16.667V16.667H6.66699V6.66699Z",
      fill
    }
  ) });
};
export {
  CopyIcon
};
